import React, { useState, createContext, useContext, useEffect, useCallback } from "react";
import { CToast, CToastBody, CToastClose, CButton } from "@coreui/react";

const ToastContext = createContext(null);

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  const removeToast = useCallback((id) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  }, []);

  // action (optional): { label, onClick } renders an inline button (e.g.
  // "Reintentar"). Actionable toasts do NOT autohide so the choice persists;
  // the close (X) acts as Cancelar. Backward compatible: omit for plain toasts.
  const addToast = useCallback((message, color = "primary", action = null) => {
    setToasts((prevToasts) => [
      ...prevToasts,
      { id: new Date().getTime() + Math.random(), message, color, action },
    ]);
  }, []);

  return (
    <ToastContext.Provider value={{ addToast }}>
      {children}
      {isClient && (
        <div
          className="position-fixed bottom-0 mb-5 start-50 translate-middle-x p-3"
          style={{ zIndex: 5 }}
        >
          {toasts.map((toast) => (
            <div key={toast.id}>
              <CToast
                autohide={!toast.action}
                visible={true}
                className={`bg-${toast.color} text-white`}
                delay={5000}
              >
                <div className="d-flex align-items-center">
                  <CToastBody>{toast.message}</CToastBody>
                  {toast.action && (
                    <CButton
                      size="sm"
                      color="light"
                      variant="outline"
                      className="me-2 ms-auto text-white"
                      onClick={() => {
                        toast.action.onClick();
                        removeToast(toast.id);
                      }}
                    >
                      {toast.action.label}
                    </CButton>
                  )}
                  <CToastClose className="me-2 m-auto" />
                </div>
              </CToast>
            </div>
          ))}
        </div>
      )}
    </ToastContext.Provider>
  );
};

export const useToast = () => {
  return useContext(ToastContext);
};
